<template>
    <div class="invoice__preview--wrap w--100">
        <div class="w-100">
            <div class="invoice__preview--contents">
                <div class="invoice__preview__top" />
                <div class="pl--15 pr--15">
                    <div class="preview__header mt--10">
                        <h1 class="text--lg text-gray-600">
                            Receipt #{{ invoiceData.invoiceNo }}
                        </h1>
                    </div>
                </div>
                
                <div class="invoice__preview--card">
                    <div class="preview__dates">
                        <div class="flex-1">
                            <p class="text--sm text--semi--bold">
                                Date Issued
                            </p>
                            <p class="text--sm mt--3">
                                {{ $format_date(invoiceData.createdAt) || '-' }}
                            </p>
                        </div>
                        <div class="flex-1">
                            <p class="text--sm text--semi--bold">
                                Date Paid
                            </p>
                            <p class="text--sm mt--3">
                                {{ $format_date(invoiceData.datePaid) || '-' }}
                            </p>
                        </div>
                        <div class="flex-1">
                            <p class="text--sm text--semi--bold">
                                Due Date
                            </p>
                            <p class="text--sm mt--3">
                                {{ $format_date(invoiceData.dueDate) || '-' }}
                            </p>
                        </div>
                    </div>
        
                    <div class="preview__details">
                        <div v-if="computedInvoiceData.user" class="preview__details__item">
                            <CustomText size="base" transform="upper" weight="semi--bold">
                                From:
                            </CustomText>
                            <div class="preview__card__item">
                                <p class="preview__card__item__title">
                                    Ziner
                                </p>
                            </div>
                        </div>
                        <div class="preview__details__item mr--10">
                            <CustomText size="base" transform="upper" weight="semi--bold">
                                Billed to:
                            </CustomText>
                            <div v-if="computedInvoiceData.client.name" class="preview__card__item">
                                <p class="preview__card__item__title">
                                    {{ computedInvoiceData.client.name }}
                                </p>
                                <p class="mt--3">
                                    {{ computedInvoiceData.client.email }}
                                </p>
                                <p class="mt--3">
                                    {{ computedInvoiceData.client.phoneNumber }}
                                </p>
                                <p class="mt--3">
                                    {{ computedInvoiceData.client.address }}
                                </p>
                                <p class="mt--3">
                                    {{ computedInvoiceData.client.country }}
                                </p>
                            </div>
                        </div>
                    </div>
        
                    <div v-if="computedInvoiceData.items.length > 1" class="mt--40 text--xl text--medium">
                        {{ computedInvoiceData.items.length }} item
                    </div>
        
                    <CustomTable 
                        :columns="tableHeaders" 
                        :data="computedInvoiceData.items" 
                        :is-checkbox="false"
                        table-type="striped"
                        class="mt--40"
                    >
                        <template #rows="data">
                            <td class="text--capitalize">
                                {{ data.itemName }}
                            </td>
                            <td>{{ data.itemQuantity }}</td>
                            <td>{{ data.itemPrice }}</td>
                        </template>
                    </CustomTable>
        
                    <div class="mt--30">
                        <div class="preview__row">
                            <div class="text--sm">
                                Subtotal:
                            </div>
                            <div class="preview__row__text">
                                {{ computedInvoiceData.invoice.subtotal }}
                            </div>
                        </div>
                        <!-- <div class="preview__row">
                            <div class="text--sm">
                                Tax:
                            </div>
                            <div class="preview__row__text">
                                {{ computedInvoiceData.invoice.tax }}
                            </div>
                        </div> -->
                        <div class="preview__row">
                            <div class="text--sm">
                                Total:
                            </div>
                            <div class="preview__row__text">
                                {{ computedInvoiceData.invoice.total }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatDateStrings } from "@/utils/date";
import CustomText from "@/components/ui/text/Text.vue";
import { CustomTable } from "@/components/ui/index";

export default {
    name: "PreviewInvoiceView",
    components: {
        CustomText,
        CustomTable,
    },

    props: {
        invoiceData: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            tableHeaders: [
                { id: "Description", accessorKey: "paymentMethod", iconName: "envelope-solid"},
                { id: "Quantity", accessorKey: "price", iconName: "user"},
                { id: "Amount", accessorKey: "duration", iconName: "buildings"},
            ],
            fetchPaymentRecord: {
                loading: false,
                err: false,
                errMsg: "",
            },
            paymentReceipt: {
                dueDate: "",
                status: "",
                datePaid: "",
                meta: "",
                invoiceNo: "",
                createdAt: "",
                subscription: {
                    currentBillingDate: "",
                    plan: "",
                    amount: "",
                    currency: "",
                    billingType: "",
                    nextBillingDate: "",
                },
            },
        };
    },

    computed: {
        profile() {
            return this.$store.getters["auth/profile"];
        },

        computedInvoiceData() {
            return {
                items: [{
                    itemName: `${this.invoiceData.items[0].service}` || "",
                    itemQuantity: 1,
                    itemPrice: `${this.$country.getSymbol(this.invoiceData?.currency, "currency")} ${this.invoiceData.items[0]?.amount || 0}` ,
                }],
                invoice: { 
                    ...this.paymentReceipt, 
                    invoiceNo: this.invoiceData?.invoiceNo,
                    subtotal: `${this.$country.getSymbol(this.invoiceData?.currency, "currency")}${this.invoiceData.items[0]?.amount}`,
                    // tax: `${this.$country.getSymbol(this.invoiceData?.currency, "currency")}${this.calculateTaxAmount(this.invoiceData.items[0]?.amount, this.invoiceData.items[0]?.meta?.vat)}`,
                    total: `${this.$country.getSymbol(this.invoiceData?.currency, "currency")}${this.invoiceData.items[0]?.amount}`,
                },
                client: {
                    name: this.profile.fullName,
                    address: this.profile.address,
                    phoneNumber: this.profile.phoneNumber,
                    email: this.profile.email,
                },
                user: undefined,
            };
        },
    },

    methods: {
        formatDate(dateString) {
            if (typeof dateString === "object") {
                let stringDate = dateString.toString();
                return formatDateStrings(stringDate) || "N/A";
            }
            return dateString && typeof dateString === "string" ? formatDateStrings(dateString) : "N/A";
        },

        calculateTaxAmount(subtotal = 0, tax) {
            if (!tax || tax?.type) return 0;

            let taxAmount = 0;

            if (tax?.type === "percentage") {
                taxAmount = taxAmount + ((tax?.amount / 100) * subtotal);
            } else {
                taxAmount = tax?.amount;
            }

            return taxAmount;
        },
    },
};
</script>